import React from 'react';

import { Risk } from 'api/queries/getRiskRegister.query';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/style/table.module.scss';
import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import {
    Risks as RisksUnion,
    probabilityOptions,
    risksOptions,
    statusOptions,
} from 'components/widgets/RiskRegister/RiskRegister.utils';
import { SearchFilter } from 'components/widgets/RiskRegister/components/Filters/components/SearchFilter';
import { TagsFilter } from 'components/widgets/RiskRegister/components/Filters/components/TagsFilter/TagsFilter';

type Status = ISelectOption<Risk['status']>;
type Probability = ISelectOption<Risk['probability']>;
type Risks = ISelectOption<RisksUnion>;

const mapper = (item) => {
    return {
        label: item.label,
        value: item.name,
    };
};

export const Filters = ({ ui }) => {
    return (
        <div key={'filters'} className={classes.filters}>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Search</div>
                <SearchFilter ui={ui} />
            </div>

            <div className={classes.selectWrapper}>
                <div className={classes.title}>Status</div>
                <Select<Status, true>
                    value={statusOptions.map(mapper).filter((item) => ui.state.status.includes(item.value))}
                    options={statusOptions.map(mapper)}
                    onChange={(value) => {
                        ui.setters.setStatus(value.map((item) => item.value));
                    }}
                    id={'status-filter'}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>

            <div className={classes.selectWrapper}>
                <div className={classes.title}>Probability</div>
                <Select<Probability, true>
                    value={probabilityOptions.filter((item) => ui.state.probability.includes(item.value))}
                    options={probabilityOptions}
                    onChange={(value) => {
                        ui.setters.setProbability(value.map((item) => item.value));
                    }}
                    id={'probability-filter'}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Probability...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>

            <div className={classes.selectWrapper}>
                <div className={classes.title}>Risks/Opportunities</div>
                <Select<Risks, true>
                    value={risksOptions.filter((item) => ui.state.risks.includes(item.value))}
                    options={risksOptions}
                    onChange={(value) => {
                        ui.setters.setRisks(value.map((item) => item.value));
                    }}
                    id={'risks-filter'}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>

            <div className={classes.selectWrapper}>
                <div className={classes.title}>Tags</div>
                <TagsFilter
                    value={ui.state.tags}
                    onChange={(value) => {
                        ui.setters.setTags(value.map((item) => item.value));
                    }}
                />
            </div>
        </div>
    );
};
